import { HOST } from '../config';
import { apiGet, apiPost, apiDelete } from '../api';
import { toast } from 'react-toastify';

export const A = {
  REQUEST_GET_COLLECTIONS: 'REQUEST_GET_COLLECTIONS',
  RECEIVE_GET_COLLECTIONS: 'RECEIVE_GET_COLLECTIONS',
  ERROR_GET_COLLECTIONS: 'ERROR_GET_COLLECTIONS',

  REQUEST_GET_COLLECTION_BY_ID: 'REQUEST_GET_COLLECTION_BY_ID',
  RECEIVE_GET_COLLECTION_BY_ID: 'RECEIVE_GET_COLLECTION_BY_ID',
  ERROR_GET_COLLECTION_BY_ID: 'ERROR_GET_COLLECTION_BY_ID',

  REQUEST_SAVE_COLLECTION: 'REQUEST_SAVE_COLLECTION',
  RECEIVE_SAVE_COLLECTION: 'RECEIVE_SAVE_COLLECTION',
  ERROR_SAVE_COLLECTION: 'ERROR_SAVE_COLLECTION',

  REQUEST_EDIT_COLLECTION: 'REQUEST_EDIT_COLLECTION',
  RECEIVE_EDIT_COLLECTION: 'RECEIVE_EDIT_COLLECTION',
  ERROR_EDIT_COLLECTION: 'ERROR_EDIT_COLLECTION',

  REQUEST_REMOVE_COLLECTION: 'REQUEST_REMOVE_COLLECTION',
  RECEIVE_REMOVE_COLLECTION: 'RECEIVE_REMOVE_COLLECTION',
  ERROR_REMOVE_COLLECTION: 'ERROR_REMOVE_COLLECTION',

  REQUEST_ADD_COLLECTION_IMAGE: 'REQUEST_ADD_COLLECTION_IMAGE',
  RECEIVE_ADD_COLLECTION_IMAGE: 'RECEIVE_ADD_COLLECTION_IMAGE',
  ERROR_ADD_COLLECTION_IMAGE: 'ERROR_ADD_COLLECTION_IMAGE',

  REQUEST_REMOVE_COLLECTION_IMAGE: 'REQUEST_REMOVE_COLLECTION_IMAGE',
  RECEIVE_REMOVE_COLLECTION_IMAGE: 'RECEIVE_REMOVE_COLLECTION_IMAGE',
  ERROR_REMOVE_COLLECTION_IMAGE: 'ERROR_REMOVE_COLLECTION_IMAGE',

  REQUEST_GET_CATALOGS: 'REQUEST_GET_CATALOGS',
  RECEIVE_GET_CATALOGS: 'RECEIVE_GET_CATALOGS',
  ERROR_GET_CATALOGS: 'ERROR_GET_CATALOGS',

  REQUEST_UPDATE_CATALOG: 'REQUEST_UPDATE_CATALOG',
  RECEIVE_UPDATE_CATALOG: 'RECEIVE_UPDATE_CATALOG',
  ERROR_UPDATE_CATALOG: 'ERROR_UPDATE_CATALOG',

  REQUEST_GET_COLLECTION_FILTERS: 'REQUEST_GET_COLLECTION_FILTERS',
  RECEIVE_GET_COLLECTION_FILTERS: 'RECEIVE_GET_COLLECTION_FILTERS',
  ERROR_GET_COLLECTION_FILTERS: 'ERROR_GET_COLLECTION_FILTERS',

  REQUEST_UPDATE_ALL_COLLECTION_FILTERS: 'REQUEST_UPDATE_ALL_COLLECTION_FILTERS',
  RECEIVE_UPDATE_ALL_COLLECTION_FILTERS: 'RECEIVE_UPDATE_ALL_COLLECTION_FILTERS',
  ERROR_UPDATE_ALL_COLLECTION_FILTERS: 'ERROR_UPDATE_ALL_COLLECTION_FILTERS',
};

export const fetchGetCollections = () => {
  return (dispatch, getState) => {
    dispatch(requestGetCollections());
    return new Promise((resolve, reject) => {
      apiGet({
        url: HOST + '/api/lite/collections',
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            dispatch(receiveGetCollections(res.collections));
            resolve(res.collections);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetCollections(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetCollections(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetCollections = () => {
  return {
    type: A.REQUEST_GET_COLLECTIONS,
  };
};

const receiveGetCollections = (data) => {
  return {
    type: A.RECEIVE_GET_COLLECTIONS,
    data,
  };
};

const errorGetCollections = (err) => {
  return {
    type: A.ERROR_GET_COLLECTIONS,
    err,
  };
};

export const fetchGetCollectionById = (id) => {
  return (dispatch, getState) => {
    dispatch(requestGetCollectionById());
    return new Promise((resolve, reject) => {
      apiGet({
        url: HOST + '/api/lite/collections?id=' + id,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            dispatch(receiveGetCollectionById(res.collections[0]));
            resolve(res.collections[0]);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetCollectionById(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetCollectionById(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetCollectionById = () => {
  return {
    type: A.REQUEST_GET_COLLECTION_BY_ID,
  };
};

const receiveGetCollectionById = () => {
  return {
    type: A.RECEIVE_GET_COLLECTION_BY_ID,
  };
};

const errorGetCollectionById = (err) => {
  return {
    type: A.ERROR_GET_COLLECTION_BY_ID,
    err,
  };
};

export const fetchSaveCollection = (data) => {
  return (dispatch, getState) => {
    dispatch(requestSaveCollection());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/collections',
        tokens: getState().auth.tokenData,
        body: data,
        callback: async (res) => {
          if (res.success) {
            const collection = await dispatch(fetchGetCollectionById(res.id));
            dispatch(receiveSaveCollection(collection));
            resolve(collection);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorSaveCollection(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorSaveCollection(err));
          reject(err);
        },
      });
    });
  };
};

const requestSaveCollection = () => {
  return {
    type: A.REQUEST_SAVE_COLLECTION,
  };
};

const receiveSaveCollection = (collection) => {
  return {
    type: A.RECEIVE_SAVE_COLLECTION,
    collection,
  };
};

const errorSaveCollection = (err) => {
  return {
    type: A.ERROR_SAVE_COLLECTION,
    err,
  };
};

export const fetchEditCollection = (data) => {
  return (dispatch, getState) => {
    dispatch(requestEditCollection());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/collections',
        tokens: getState().auth.tokenData,
        body: data,
        callback: async (res) => {
          if (res.success) {
            const collection = await dispatch(fetchGetCollectionById(res.id));
            dispatch(receiveEditCollection(collection));
            resolve(collection);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorEditCollection(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorEditCollection(err));
          reject(err);
        },
      });
    });
  };
};

const requestEditCollection = () => {
  return {
    type: A.REQUEST_EDIT_COLLECTION,
  };
};

const receiveEditCollection = (collection) => {
  return {
    type: A.RECEIVE_EDIT_COLLECTION,
    collection,
  };
};

const errorEditCollection = (err) => {
  return {
    type: A.ERROR_EDIT_COLLECTION,
    err,
  };
};

export const fetchRemoveCollection = (id) => {
  return (dispatch, getState) => {
    dispatch(requestRemoveCollection());
    return new Promise((resolve, reject) => {
      apiDelete({
        url: HOST + '/api/lite/collections?id=' + id,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            dispatch(receiveRemoveCollection(id));
            resolve(id);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorRemoveCollection(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorRemoveCollection(err));
          reject(err);
        },
      });
    });
  };
};

const requestRemoveCollection = () => {
  return {
    type: A.REQUEST_REMOVE_COLLECTION,
  };
};

const receiveRemoveCollection = (id) => {
  return {
    type: A.RECEIVE_REMOVE_COLLECTION,
    id,
  };
};

const errorRemoveCollection = (err) => {
  return {
    type: A.ERROR_REMOVE_COLLECTION,
    err,
  };
};

export const fetchAddCollectionImage = (newImage) => {
  const formData = new FormData();
  Object.keys(newImage).forEach((key) => {
    formData.append(key, newImage[key]);
  });
  return (dispatch, getState) => {
    dispatch(requestAddCollectionImage());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/collections/image',
        tokens: getState().auth.tokenData,
        formData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveAddCollectionImage(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorAddCollectionImage(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorAddCollectionImage(err));
          reject(err);
        },
      });
    });
  };
};

const requestAddCollectionImage = () => {
  return {
    type: A.REQUEST_ADD_COLLECTION_IMAGE,
  };
};

const receiveAddCollectionImage = (data) => {
  return {
    type: A.RECEIVE_ADD_COLLECTION_IMAGE,
    data,
  };
};

const errorAddCollectionImage = (err) => {
  return {
    type: A.ERROR_ADD_COLLECTION_IMAGE,
    err,
  };
};

export const fetchRemoveCollectionImage = (collectionId) => {
  return (dispatch, getState) => {
    dispatch(requestRemoveCollectionImage());
    return new Promise((resolve, reject) => {
      apiDelete({
        url: HOST + '/api/lite/collections/image?id=' + collectionId,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveRemoveCollectionImage(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorRemoveCollectionImage(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorRemoveCollectionImage(err));
          reject(err);
        },
      });
    });
  };
};

const requestRemoveCollectionImage = () => {
  return {
    type: A.REQUEST_REMOVE_COLLECTION_IMAGE,
  };
};

const receiveRemoveCollectionImage = (data) => {
  return {
    type: A.RECEIVE_REMOVE_COLLECTION_IMAGE,
    data,
  };
};

const errorRemoveCollectionImage = (err) => {
  return {
    type: A.ERROR_REMOVE_COLLECTION_IMAGE,
    err,
  };
};

export const fetchGetCatalogs = () => {
  return (dispatch, getState) => {
    dispatch(requestGetCatalogs());
    return new Promise((resolve, reject) => {
      apiGet({
        url: HOST + '/api/lite/settings/catalog',
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            dispatch(receiveGetCatalogs(res.catalogs));
            resolve(res.catalogs);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetCatalogs(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetCatalogs(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetCatalogs = () => {
  return {
    type: A.REQUEST_GET_CATALOGS,
  };
};

const receiveGetCatalogs = (data) => {
  return {
    type: A.RECEIVE_GET_CATALOGS,
    data,
  };
};

const errorGetCatalogs = (err) => {
  return {
    type: A.ERROR_GET_CATALOGS,
    err,
  };
};

export const fetchUpdateCatalog = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateCatalog());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/settings/catalog',
        body: data,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            dispatch(receiveUpdateCatalog());
            const result = await dispatch(fetchGetCatalogs());
            resolve(result);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateCatalog(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetCollections(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateCatalog = () => {
  return {
    type: A.REQUEST_UPDATE_CATALOG,
  };
};

const receiveUpdateCatalog = (data) => {
  return {
    type: A.RECEIVE_UPDATE_CATALOG,
    data,
  };
};

const errorUpdateCatalog = (err) => {
  return {
    type: A.ERROR_UPDATE_CATALOG,
    err,
  };
};

export const fetchGetCollectionFilters = (collectionId) => {
  return (dispatch, getState) => {
    dispatch(requestGetCollectionFilters());
    return new Promise((resolve, reject) => {
      apiGet({
        url: HOST + `/api/lite/products/filters/?collectionId=${collectionId}`,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            dispatch(receiveGetCollectionFilters());
            resolve(res.filterBlocks);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetCollectionFilters(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetCollectionFilters(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetCollectionFilters = () => {
  return {
    type: A.REQUEST_GET_COLLECTION_FILTERS,
  };
};

const receiveGetCollectionFilters = (data) => {
  return {
    type: A.RECEIVE_GET_COLLECTION_FILTERS,
    data,
  };
};

const errorGetCollectionFilters = (err) => {
  return {
    type: A.ERROR_GET_COLLECTION_FILTERS,
    err,
  };
};

export const fetchUpdateAllCollectionFilters = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateAllCollectionFilters());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + `/api/lite/products/filters/for/collection`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            toast.info('Фильтры коллекции успешно обновлены!');
            dispatch(receiveUpdateAllCollectionFilters());
            resolve();
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateAllCollectionFilters(err));
            toast.error('Ошибка при сохранении фильтров коллекции');
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateAllCollectionFilters(err));
          toast.error('Ошибка при сохранении фильтров коллекции');
          reject(err);
        },
      });
    });
  };
};

const requestUpdateAllCollectionFilters = () => {
  return {
    type: A.REQUEST_UPDATE_ALL_COLLECTION_FILTERS,
  };
};

const receiveUpdateAllCollectionFilters = (data) => {
  return {
    type: A.RECEIVE_UPDATE_ALL_COLLECTION_FILTERS,
    data,
  };
};

const errorUpdateAllCollectionFilters = (err) => {
  return {
    type: A.ERROR_UPDATE_ALL_COLLECTION_FILTERS,
    err,
  };
};
